// extracted by mini-css-extract-plugin
module.exports = {"button":"button__15BUv","placeholder":"placeholder__2IYvP"};